import type { TranslateFunction } from '../types/front/common';

export function getTranslatedStatusState(t: TranslateFunction, state?: string) {
  return t(`leave.status.state.${state}`) === `leave.status.state.${state}`
    ? state
    : t(`leave.status.state.${state}`);
}
